/**
 * Created by xupengwei on 2018/6/26.
 * Modified by heyushuang on 2019/9/26.
 */
// let importArr = [];
let enUSI18n = {
  'timeout': 'Timeout',
  'btnNext': 'Next',
  'commonTitle': 'Installation',
  'modelTitle': 'Alcidae Garager 2 Compatibility Checker',
  'commonNodata': 'No Data',
  'commonLoading': 'Loading',
  'openGLoading': 'Opening the garage door...',
  'commonFail': 'Failed',
  'commonTryAgain': 'Try again',
  'commonNo': 'No',
  'commonYes': 'Yes',
  'commonOk': 'OK',
  'commonSubmit': 'Submit',
  'commonCancel': 'Cancel',
  'modelDescItem1': 'Check the model number of the motor',
  'modelDescItem2': 'Select your brand and model number base on the information labeled on your motor.',
  'modelDescItem3': 'If you can see your device in the list, that means your device is compatible.',
  'modelDescTips': [
      'If the model of your motor is not listed, Please refer to',
      ' the typical motor diagram ',
      'for installation'
    ],
  'factoryPlaceholder': 'Select Manufacturer',
  'modelPlaceholder': 'Select Model',
  'appAlcidaes': 'Alcidae',
  'appDanales': 'Danale',
};
// Object.assign(enUSI18n, ...importArr);

export default enUSI18n;



// WEBPACK FOOTER //
// ./src/i18n/messages/en-US.i18n.js